import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

async function getPharmacyService(serviceId) {
  if (!serviceId) throw new Error('Invalid request: Service ID is required');

  const response = await axiosPrivate.get(`/v3/pharmacist/services/${serviceId}`);
  const service = response.data;

  if (!service) throw new Error('Failed to load service: Malformed response');

  return service;
}
export const serviceQueryKey = (serviceId) => ['service', serviceId];

export default function useGetPharmacyService({ serviceId, silenceErrors = false }) {
  return useQuery({
    queryKey: serviceQueryKey(serviceId),
    queryFn: () => getPharmacyService(serviceId),
    enabled: Boolean(serviceId),
    meta: { errorMessage: 'Failed to load service', silenceErrors },
    refetchOnWindowFocus: false,
    ...(silenceErrors && { retry: false }),
  });
}
